export default "__VITE_ASSET__DW3W9fPL__"